import { useQuery } from "@tanstack/react-query";
import client from "./client";
import type { AuditLog, PaginatedResponse } from "./types";

export function useAuditLogs(params?: Record<string, string>) {
  return useQuery<PaginatedResponse<AuditLog>>({
    queryKey: ["audit-logs", params],
    queryFn: async () => {
      const { data } = await client.get("/audit-logs/", { params });
      return data;
    },
  });
}
